import React, { useContext } from 'react';
import Select from 'react-select';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import { updateVuln } from 'store/Manage/actions';
import { selectVulnDetail, selectPermissions } from 'store/Manage/selectors';
import { selectReadOnly } from 'store/Faraday/selectors';
import { statusSelect } from 'Common/styles/style';
import { capitalize } from 'utils/stringUtils';
import { status as statusList } from 'Screens/Constants';
import Wrapper from './styled';
import { ThemeContext } from 'Context';

const StatusPicker = () => {
  const dispatch = useDispatch();
  const vuln = useSelector(selectVulnDetail);

  const readOnly = useSelector(selectReadOnly);
  const permissions = useSelector(selectPermissions);
  const status = get(vuln, 'status', '');
  const value = {
    label: capitalize(status),
    value: status
  };

  const { themeStyles, theme } = useContext(ThemeContext);
  const lightTheme = theme === 'light';

  return (
    <Wrapper isDisabled={ readOnly || !permissions.update.allowed }>
      <Select
        styles={ statusSelect(themeStyles, lightTheme) }
        isSearchable={ false }
        isDisabled={ readOnly || !permissions.update.allowed }
        value={ value }
        onChange={ (e) => dispatch(updateVuln(vuln, 'status', e.value)) }
        options={ statusList.map((element) => ({ label: element.desc, value: element.name })) }
      />
    </Wrapper>
  );
};

export default StatusPicker;
